import React from 'react';
import AnswerKeyHeader from './AnswerKeyHeader';
import Prompt from './Prompt';
import Lure from './Lure';

const AnswerKeyDialog = ({ lesson, data, dir }) => {
  // using a try to catch any errors in the dialog segment structure, since it's possible that some segments may be malformed or missing expected fields. This way we can log the error and skip rendering that segment instead of crashing the entire answer key.
  return data.content.dialog_segments.map((segment, index) => {
    try {
      // intentionally unsafe (no optional chaining)
      const initialPrompt = segment.initial_prompts[0].text;
      const initialResponses = segment.initial_responses;
      const selfCorrectionPrompt = segment.self_correction_prompts[0].text;
      const selfCorrectionResponses = segment.self_correction_responses;

      return (
        <React.Fragment key={index}>
          <div
            className="page"
            style={{
              width: '8.5in',
              minHeight: '11in',
              padding: '0.5in',
              boxSizing: 'border-box',
              margin: '0 auto',
              border: '1px #D3D3D3 solid',
              borderRadius: '4px',
              background: 'white',
              pageBreakAfter: 'always',
              color: '#333'
            }}
          >
            <AnswerKeyHeader
              lesson={lesson}
              title={`${data.title} - Dialog ${index + 1} - Initial Prompt`}
              label={data.label}
              page={data}
            />
            {Prompt(initialPrompt, 'Initial Prompt', dir)}
            {initialResponses.map((lure, idx) => {
              const is_correct = lure.is_correct ? lure.is_correct : false;
              return Lure(lure.lure_text, is_correct, dir, idx);
            })}
          </div>

          <div
            className="page"
            style={{
              width: '8.5in',
              minHeight: '11in',
              padding: '0.5in',
              boxSizing: 'border-box',
              margin: '0 auto',
              border: '1px #D3D3D3 solid',
              borderRadius: '4px',
              background: 'white',
              pageBreakAfter: 'always',
              color: '#333'
            }}
          >
            <AnswerKeyHeader
              lesson={lesson}
              title={`${data.title} - Dialog ${
                index + 1
              } - Self Correction Prompt`}
              label={data.label}
              page={data}
            />
            {Prompt(selfCorrectionPrompt, 'Self Correction Prompt', dir)}
            {selfCorrectionResponses.map((lure, idx) => {
              const is_correct = lure.is_correct ? lure.is_correct : false;
              return Lure(lure.lure_text, is_correct, dir, idx);
            })}
          </div>
        </React.Fragment>
      );
    } catch (err) {
      console.error(`❌ Dialog segment FAILED at index ${index}`, {
        error: err.message,
        segment,
        checks: {
          hasInitialPrompts: !!segment.initial_prompts,
          initialPromptsLength: segment.initial_prompts?.length,
          hasInitialResponses: !!segment.initial_responses,
          hasSelfCorrectionPrompts: !!segment.self_correction_prompts,
          selfCorrectionPromptsLength: segment.self_correction_prompts?.length,
          hasSelfCorrectionResponses: !!segment.self_correction_responses
        }
      });

      // return a placeholder for the failed segment, so we can visually identify it in the answer key and know that it needs to be reviewed and fixed in the source data. This way we can still generate an answer key even if some segments are broken, and we can easily spot and address the issues later.
      return (
        <div className="page" key={index}>
          <h2>Dialog segment FAILED</h2>
          <pre>{JSON.stringify(segment, null, 2)}</pre>
        </div>
      );
    }
  });
};

export default AnswerKeyDialog;
